import { useState, useRef, useEffect } from "react";
import { Props } from "./types";

export const Timer = ({ timeLimit, onTimesUp }: Props) => {
  const intervalId = useRef<ReturnType<typeof setInterval>>(null!);
  const [timer, setTimer] = useState(timeLimit || 60);

  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    let seconds: string = String(time % 60);

    if (Number(seconds) < 10) {
      seconds = `0${seconds}`;
    }

    return `${minutes}:${seconds}`;
  };

  useEffect(() => {
    if (timer <= 0) {
      onTimesUp();
      clearInterval(intervalId.current);
    }
  }, [timer]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (timer > 0) {
      intervalId.current = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return <span>{formatTime(timer)}</span>;
};
